import { action, computed, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";
import { EngToolStore } from "./EngToolStore";

export class ActivitiesStore {
  store: EngToolStore;
  loading = false;
  list = [];
  keyword = "";

  constructor(store: EngToolStore) {
    makeAutoObservable(this, {
      store: false,
      activities: computed,
    });
    this.store = store;
  }

  get activities() {
    const kw = this.keyword.toLocaleLowerCase();

    return this.list.filter(
      (x: any) => x.activityName.toLocaleLowerCase().includes(kw) || x.activityType.toLocaleLowerCase().includes(kw)
    );
  }

  @action
  refresh() {
    this.loading = true;
    Api.engTool
      .activities()
      .then((res) => {
        runInAction(() => {
          this.list = res.data.engToolActivities;
        });
      })
      .finally(() => (this.loading = false));
  }
}
